import api from "./index";

const BASE = "/mail";

export const sendSupportEmail = async ({ subject, body, sender_email, admin_email }: { subject: string, body: string, sender_email: string, admin_email: string | null }) => {
    try {
        const response = await api.post(`${BASE}/send`, {
            subject,
            body,
            sender_email,
            admin_email
        });
        return response.data;
    } catch (error) {
        console.error("Failed to send support email:", error);
        throw error;
    }
};

export const sendEmailtoUser = async ({ subject, body, receiving_email }: { subject: string, body: string, receiving_email: string }) => {
    try {
        const response = await api.post(`${BASE}/sendtouser`, {
            subject,
            body,
            receiving_email,
        });
        return response.data;
    } catch (error) {
        console.error("Failed to send support email:", error);
        throw error;
    }
};